import React from 'react';
import c from 'classnames';

import type { BaseCardProps } from './types';

import CardContent from './Content';
import CardImage from './Image';
import CardSubtitle from './Subtitle';
import CardTitle from './Title';
import CardTags from './Tags';
import CardLabels from './Labels';
import CardLink from './Link';

import './style.scss';

type CardProps = Pick<BaseCardProps, 'className' | 'withLink'>;

interface CardSubComponents {
  Image: typeof CardImage;
  Content: typeof CardContent;
  Title: typeof CardTitle;
  Subtitle: typeof CardSubtitle;
  Tags: typeof CardTags;
  Labels: typeof CardLabels;
  Link: typeof CardLink;
}

const Card: React.FC<CardProps> & CardSubComponents = (props) => {
  const { className, children, withLink } = props;

  const classNames = c(
    'Card',
    className,
    {
      'u-link-box u-focus-ring--within': withLink,
    },
  );

  return (
    <div className={classNames}>
      {children}
    </div>
  );
};

Card.Image = CardImage;
Card.Content = CardContent;
Card.Title = CardTitle;
Card.Subtitle = CardSubtitle;
Card.Tags = CardTags;
Card.Labels = CardLabels;
Card.Link = CardLink;

export default Card;
